module.exports = __webpack_public_path__ + "media/src/application/media/v2-img-1-8ba64ba496390682c0d3326af71d1aff.png";